var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-split-settings" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-between mb-3",
        },
        [
          _c("label", { staticClass: "font-weight-bold mb-0" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.__t("SPLIT_RULES")) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "primary" },
              on: { click: _vm.addSplitRow },
            },
            [
              _c("i", { staticClass: "fal fa-plus mr-1" }),
              _vm._v("\n            " + _vm._s(_vm.__t("ADD")) + "\n        "),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.splitRows.length <= 0
        ? _c("div", { staticClass: "alert alert-info" }, [
            _vm._v("\n        Split rules ще не додані\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.splitRows.length > 0
        ? _c(
            "b-tabs",
            { attrs: { pills: "", card: "" } },
            _vm._l(_vm.splitRows, function (row, rowIndex) {
              return _c(
                "b-tab",
                {
                  key: row._key || rowIndex,
                  attrs: { active: rowIndex === 0 },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "px-3" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.getTabTitle(row, rowIndex)) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c("div", { staticClass: "split-card" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center mb-3",
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            "\n                        Split #" +
                              _vm._s(rowIndex + 1) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeSplitRow(rowIndex)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.__t("REMOVE")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row mb-3" },
                      _vm._l(_vm.rowFieldKeys(row), function (fieldKey) {
                        return _c(
                          "div",
                          { key: fieldKey, staticClass: "col-12" },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: fieldKey } },
                              [
                                fieldKey === "splitReceiverId"
                                  ? _c("v-select", {
                                      attrs: {
                                        value: _vm.getSplitterOption(
                                          row[fieldKey]
                                        ),
                                        options: _vm.splitters,
                                        label: "label",
                                        clearable: true,
                                        searchable: true,
                                        disabled: _vm.isLoadSplitters,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setSplitterValue(
                                            row,
                                            fieldKey,
                                            $event
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function (option) {
                                              return [
                                                _c("div", [
                                                  _c("strong", [
                                                    _vm._v(_vm._s(option.name)),
                                                  ]),
                                                  _vm._v(" "),
                                                  option.okpo || option.edrpou
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "small text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                option.okpo ||
                                                                  option.edrpou
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "selected-option",
                                            fn: function (option) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(option.name) +
                                                      "\n                                        "
                                                  ),
                                                  option.okpo || option.edrpou
                                                    ? _c("small", [
                                                        _vm._v(
                                                          "\n                                            / " +
                                                            _vm._s(
                                                              option.okpo ||
                                                                option.edrpou
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _c("b-form-input", {
                                      attrs: { placeholder: fieldKey },
                                      on: { input: _vm.emitChange },
                                      model: {
                                        value: row[fieldKey],
                                        callback: function ($$v) {
                                          _vm.$set(row, fieldKey, $$v)
                                        },
                                        expression: "row[fieldKey]",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "split-orgs" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between mb-3",
                        },
                        [
                          _c("div", [
                            _c(
                              "label",
                              { staticClass: "font-weight-bold mb-0" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.__t("CATEGORIES")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm._v(
                                "\n                                Виберіть організацію і категорії для цього split\n                            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-muted small" }, [
                            _vm._v(
                              "\n                            Всього вибрано: " +
                                _vm._s(_vm.getTotalSelectedForRow(row)) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isLoadOrganizations
                        ? _c("div", { staticClass: "p-3" }, [
                            _c("i", { staticClass: "fal fa-spinner fa-spin" }),
                            _vm._v(
                              "\n                        Завантаження організацій...\n                    "
                            ),
                          ])
                        : _vm.drawOrganizations.length <= 0
                        ? _c("div", { staticClass: "alert alert-info" }, [
                            _vm._v(
                              "\n                        Немає організацій з товарами\n                    "
                            ),
                          ])
                        : _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Організація" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      value: _vm.getSelectedOrg(row),
                                      options: _vm.drawOrganizations,
                                      label: "org_label",
                                      clearable: false,
                                      searchable: true,
                                      placeholder: "Виберіть організацію...",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.setSelectedOrg(row, $event)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "option",
                                          fn: function (org) {
                                            return [
                                              _c("div", [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(_vm.getOrgTitle(org))
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small text-muted",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            ID: " +
                                                        _vm._s(org.id) +
                                                        " / Товарів: " +
                                                        _vm._s(
                                                          org.attached_products_clean_count
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "selected-option",
                                          fn: function (org) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.getOrgTitle(org)
                                                    ) +
                                                    "\n                                        "
                                                ),
                                                _c(
                                                  "small",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            / " +
                                                        _vm._s(
                                                          org.attached_products_clean_count
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.getSelectedOrg(row)
                                ? _c(
                                    "div",
                                    { staticClass: "alert alert-light border" },
                                    [
                                      _vm._v(
                                        "\n                            Виберіть організацію, щоб показати категорії\n                        "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "org-active-card" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "org-active-head" },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "org-active-title",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.getOrgTitle(
                                                        _vm.getSelectedOrg(row)
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "org-active-meta",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        ID: " +
                                                    _vm._s(
                                                      _vm.getSelectedOrg(row).id
                                                    ) +
                                                    " /\n                                        Вибрано: " +
                                                    _vm._s(
                                                      _vm.getTotalSelectedForRow(
                                                        row
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    size: "sm",
                                                    variant:
                                                      "outline-secondary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearOrgCategories(
                                                        row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(_vm.__t("CLEAR")) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "outline-primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.loadCategories(
                                                        _vm.getSelectedOrg(row),
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fal fa-sync",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isCategoryLoading(
                                        _vm.getSelectedOrg(row).id
                                      )
                                        ? _c("div", { staticClass: "p-3" }, [
                                            _c("i", {
                                              staticClass:
                                                "fal fa-spinner fa-spin",
                                            }),
                                            _vm._v(
                                              "\n                                Завантаження категорій...\n                            "
                                            ),
                                          ])
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "categories-scroll",
                                            },
                                            [
                                              _c("categlist", {
                                                attrs: {
                                                  categories:
                                                    _vm.getOrgCategoriesForRow(
                                                      row,
                                                      _vm.getSelectedOrg(row)
                                                    ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.setActiveCategory(
                                                      $event,
                                                      row,
                                                      rowIndex,
                                                      _vm.getSelectedOrg(row)
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                    ]),
                  ]),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }